import { Component } from '@angular/core';

import { ConfigureService } from '@app/configure/services/configure.service';
import { ModalService } from '@app/core/services/modal.service';
import { ToastService } from '@app/core/services/toast.service';

import { Modal } from '@app/core/models/modal.model';
import { ModalAction } from '@app/core/models/modal-action.model';
import { concat } from 'rxjs';

@Component({
	selector: 'cng-finance-locked-modal',
	templateUrl: './finance-locked.component.html',
})
export class ConfigureFinanceLockedModalComponent {
	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {ModalService} modal_service
	 * @param {ConfigureService} configure_service
	 * @param {ToastService} toast_service
	 */
	constructor(
		private modal_service: ModalService,
		private configure_service: ConfigureService,
		private toast_service: ToastService
	) {
		this.constructModal();
	}

	/**
	 * Constructs modal.
	 */
	constructModal(): void {
		this.modal_service.setConfig(
			new Modal({
				name: 'finance_locked_modal',
				title: 'Locked!',
				actions: [
					new ModalAction({
						id: 'cancel',
						name: 'Cancel',
						large: true,
						click: () => {
							this.modal_service.close();
						},
					}),
					new ModalAction({
						id: 'unlock',
						name: 'Unlock Deal',
						bias: 'positive',
						large: true,
						showLoading: true,
						click: (action: ModalAction) => {
							this.configure_service.deleteFinanceQuotes(false).subscribe((response1) => {
								this.configure_service.saveCustomiseReview(false).subscribe((response2) => {
									this.configure_service.setFinanceLocked(false, false).subscribe((response3) => {
										if (response1 && response2 && response3) {
											action.loading = false;
											this.configure_service.setData();
											this.toast_service.success('Deal Unlocked. Changes are allowed.');
											this.modal_service.close();
										}
									});
								});
							});
						},
					}),
				],
			})
		);
	}
}
